import { handleActions } from "redux-actions";
import { BRAND_SHIPPING_ACCOUNTS_FETCH_COMPLETE, BRAND_SHIPPING_ACCOUNTS_REQUEST } from "constants/action-types";

interface IState {
    error?: boolean;
    isFetching: boolean;
    results: string[];
}

const initialState: IState = {
    error: undefined,
    isFetching: false,
    results: [],
};

export const shippingAccounts = handleActions(
    {
        [BRAND_SHIPPING_ACCOUNTS_REQUEST]: (state: IState): IState => {
            return {
                ...state,
                isFetching: true,
            };
        },
        [BRAND_SHIPPING_ACCOUNTS_FETCH_COMPLETE]: (state: IState, { payload, error }: any): IState => {
            if (error) {
                return {
                    ...state,
                    error: true,
                    isFetching: false,
                };
            }

            return {
                ...state,
                error,
                isFetching: false,
                results: state.results.length ? (state.results.concat(payload) as string[]) : payload,
            };
        },
    },
    initialState
);
